module.exports = __webpack_public_path__ + "static/media/interview-view-action.c305dbc7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interview-view-action.svg
// module id = 1319
// module chunks = 1